import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "heart",
  "use": "heart-usage",
  "viewBox": "0 0 51.7 44.9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 51.7 44.9\" id=\"heart\"><path d=\"M35.7 3.5c-4.1 0-7.7 2-9.9 5.2-2.2-3.1-5.8-5.2-9.9-5.2-6.6 0-12 5.4-12 12 0 13.9 15.3 25.9 22 25.9s22-12.1 22-25.9c-.1-6.6-5.5-12-12.2-12z\" class=\"st0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol